import React from "react";
import { Box, Icon, Typography } from "@mui/material";
import WorkHistoryOutlinedIcon from "@mui/icons-material/WorkHistoryOutlined";
import SecurityIcon from "@mui/icons-material/Security";
import SupportAgentTwoToneIcon from "@mui/icons-material/SupportAgentTwoTone";

import { t } from "i18next";

import "./AchievementsStyle.css";

function Achievements() {
  const achievementsDataTrns = t("achievements", { returnObjects: true });
  return (
    <Box sx={{ padding: "50px 0", textAlign: "center" }}>
      {/* <Typography
        variant="h4"
        sx={{ marginBottom: "40px", fontWeight: "bold", color: "#333" }}
      >
        Our Achievements
      </Typography> */}

      <Box
        sx={{
          display: "flex",
          justifyContent: "space-around",
          flexWrap: "wrap",
          gap: "20px",
        }}
      >
        {/* Loop through achievements data */}
        {Object.entries(achievementsDataTrns).map(([key, item]) => (
          <Box className="achievement-box" key={key}>
            <Icon
              style={{
                fontSize: 50,
                width: "70px",
                height: "70px",
                padding: "auto",
                color: "var(--primary)",
                marginBottom: "15px",
              }}
            >
              {/* Render icons dynamically based on the `icon` value */}
              {item.icon === "WorkHistoryOutlinedIcon" && (
                <WorkHistoryOutlinedIcon
                  sx={{
                    fontSize: 70,
                    marginBottom: "15px",
                  }}
                />
              )}
              {item.icon === "SecurityIcon" && (
                <SecurityIcon
                  sx={{
                    fontSize: 70,
                    marginBottom: "15px",
                  }}
                />
              )}
              {item.icon === "SupportAgentTwoToneIcon" && (
                <SupportAgentTwoToneIcon
                  sx={{
                    fontSize: 70,
                    marginBottom: "15px",
                  }}
                />
              )}
            </Icon>

            {/* <Typography
              variant="h6"
              sx={{
                color: "var(--primary)",
                fontSize: "2.5em",
                fontWeight: "900",
              }}
            >
              {item.number}
            </Typography> */}

            <h5
              className="oz-subtitle"
              style={{
                fontWeight: "600",
                lineHeight: 1.7,
                fontSize: "1em",
              }}
            >
              {item.title}
            </h5>
          </Box>
        ))}
      </Box>
    </Box>
  );
}

export default Achievements;
